import React from "react";
import { Link, useNavigate } from "react-router-dom";
import "./Footer.css";

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const navigate = useNavigate();

  // Function to handle navigation with refresh
  const handleNavigation = (path) => {
    navigate(path); // navigate first
    window.scrollTo(0, 0); // scroll to top
    setTimeout(() => {
      window.location.reload(); // refresh the page after navigation
    }, 100); 
  };

  return (
    <footer className="footer">
      <div className="footer-container">
        {/* Main Footer Content */}
        <div className="footer-content">
          {/* Brand Section */}
          <div className="footer-brand">
            <h3 className="footer-logo">
              Ritesh Gajjar <span className="logo-emoji">📊</span>
            </h3>
            <p className="footer-tagline">
              Transforming data into insights • Data Scientist & Analyst
            </p>
            <div className="footer-social">
              <a
                href="https://www.instagram.com/itz_ritesh_1510/"
                target="_blank"
                rel="noopener noreferrer"
                className="social-link"
                aria-label="Instagram"
              >
                <span className="social-icon">📸</span>
                <span className="social-text">Instagram</span>
              </a>
              <a
                href="https://www.linkedin.com/in/ritesh-gajjar/"
                target="_blank"
                rel="noopener noreferrer"
                className="social-link"
                aria-label="LinkedIn"
              >
                <span className="social-icon">💼</span>
                <span className="social-text">LinkedIn</span>
              </a>
              <a
                href="https://wa.me/918980614160?text=Hello%20Ritesh%2C%20I%27m%20from%20your%20website!%20👋%20😊%20🔗"
                target="_blank"
                rel="noopener noreferrer"
                className="social-link"
                aria-label="WhatsApp"
              >
                <span className="social-icon">💬</span>
                <span className="social-text">WhatsApp</span>
              </a>
              <a
                href="https://github.com/Ritesh151/"
                target="_blank"
                rel="noopener noreferrer"
                className="social-link"
                aria-label="GitHub"
              >
                <span className="social-icon">🐙</span>
                <span className="social-text">GitHub</span>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div className="footer-links">
            <h4 className="footer-heading">Navigate 🧭</h4>
            <ul className="footer-nav">
              <li><button onClick={() => handleNavigation("/")}>Home 🏠</button></li>
              <li><button onClick={() => handleNavigation("/about")}>About 👨‍💻</button></li>
              <li><button onClick={() => handleNavigation("/skills")}>Skills 🛠️</button></li>
              <li><button onClick={() => handleNavigation("/projects")}>Projects 🚀</button></li>
              <li><button onClick={() => handleNavigation("/contact")}>Contact 📞</button></li>
            </ul>
          </div>

          {/* Contact Info */}
          <div className="footer-contact">
            <h4 className="footer-heading">Get in Touch 📬</h4>
            <div className="contact-info">
              <p className="contact-item">
                <span className="contact-icon">📧</span>
                <a href="mailto:ritesh.work.1510@gmail.com" className="contact-link">
                  ritesh.work.1510@gmail.com
                </a>
              </p>
              <p className="contact-item">
                <span className="contact-icon">📱</span>
                <span>+91 8980614160 </span>
              </p>
              <p className="contact-item">
                <span className="contact-icon">📍</span>
                <span>Ahmedabad, gujarat</span>
              </p>
            </div>
          </div>

          {/* Newsletter Signup */}
          <div className="footer-newsletter">
            <h4 className="footer-heading">Stay Updated 🔔</h4>
            <p className="newsletter-text">
              Get the latest data insights and project updates
            </p>
            <form className="newsletter-form">
              <input
                type="email"
                placeholder="Your email address"
                className="newsletter-input"
                required
              />
              <button type="submit" className="newsletter-btn">
                Subscribe 🌟
              </button>
            </form>
          </div>
        </div>

        {/* Footer Bottom */}
        <div className="footer-bottom">
          <div className="footer-bottom-content">
            <p className="copyright">
              © {currentYear} Ritesh Gajjar. All rights reserved.
              <span className="heart-emoji"> 🧡</span>
            </p>
            <div className="legal-links">
              <button onClick={() => handleNavigation("/privacy")}>Privacy Policy</button>
              <button onClick={() => handleNavigation("/terms")}>Terms of Service</button>
              <button onClick={() => handleNavigation("/sitemap")}>Sitemap</button>
            </div>
          </div>
        </div>
      </div>

      {/* Back to Top Button */}
      <button
        className="back-to-top"
        onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
        aria-label="Back to top"
      >
        ↑
      </button>
    </footer>
  );
};

export default Footer;
